import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { EmbedService } from '../../../../embed-layout/common/services/embed.service';
import { Subject, take, takeUntil } from 'rxjs';
import { EmbedData } from '../../data/embed';
import { environment } from 'src/environments/environment';
import { ThreeGraphqlService } from 'src/app/core/graphql/three/services/three-graphql.service';

@Component({
  selector: 'share-setting-tool',
  imports: [MatSlideToggleModule, CommonModule, FormsModule],
  templateUrl: './share-setting-tool.component.html',
  styleUrl: './share-setting-tool.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareSettingToolComponent implements OnInit, OnDestroy {
  public iframeCode: string | undefined = undefined;

  public embedData: EmbedData | undefined;

  private unsubscribeAll: Subject<any> = new Subject();

  constructor(
    private threeGraphqlService: ThreeGraphqlService,
    private emebedService: EmbedService,
    private cd: ChangeDetectorRef,
  ) {}

  //--------------------------------------------------------------------------------------------------------
  // @ Life Circle
  //--------------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.getEmbedData();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
    this.unsubscribeAll.unsubscribe();
  }

  //--------------------------------------------------------------------------------------------------------
  // @ Public Method
  //--------------------------------------------------------------------------------------------------------

  public onChangeCapture(): void {
    this.emebedService.embedData = this.embedData;
    this.emebedService.updateEmbedData();
  }

  public onChangeFullScreen(): void {
    this.emebedService.embedData = this.embedData;
    this.emebedService.updateEmbedData();
  }

  public onChangeAutoRotate(): void {
    this.emebedService.embedData = this.embedData;
    this.emebedService.updateEmbedData();
  }

  public onChangeFile(event: any): void {
    if (!this.embedData) return;
    const file = event.target.files[0];
    if (!file) return;
    this.threeGraphqlService
      .updateCompanyProjectToFile(this.embedData?.uuid, {
        cover: file,
      })
      .pipe(take(1))
      .subscribe((embedData: EmbedData) => {
        this.emebedService.embedData = embedData;
      });
  }

  //--------------------------------------------------------------------------------------------------------
  // @ Private Method
  //--------------------------------------------------------------------------------------------------------

  private getEmbedData(): void {
    this.emebedService.embedData$.pipe(takeUntil(this.unsubscribeAll)).subscribe((embedData) => {
      if (!embedData) return;
      this.embedData = embedData;
      this.iframeCode = ` <iframe src="${environment.origin}/embed/${this.embedData.uuid}" ${this.embedData.isFullScreen ? 'allow="fullscreen" allowfullscreen' : ''}></iframe>`;
      this.cd.markForCheck();
    });
  }
}
